import { render, staticRenderFns } from "./ProfileDataForm.vue?vue&type=template&id=387d6649&scoped=true&lang=pug"
import script from "./ProfileDataForm.vue?vue&type=script&lang=js"
export * from "./ProfileDataForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileDataForm.vue?vue&type=style&index=0&id=387d6649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d6649",
  null
  
)

export default component.exports